(() => {
  const getDrawer = () => document.querySelector('cart-drawer');
  const getCartLink = () => document.querySelector('#cart-icon-bubble');
  const cartPath = (window.routes && window.routes.cart_url) || '/cart';

  const openDrawer = () => {
    const drawer = getDrawer();
    if (drawer && typeof drawer.open === 'function') {
      drawer.open(getCartLink() || undefined);
      return true;
    }
    return false;
  };

  const renderCartSections = (sections) => {
    const drawer = getDrawer();

    if (drawer && sections && sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
      drawer.renderContents({ sections });
      return;
    }

    if (sections && sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const source = html.querySelector('.shopify-section');
      if (bubble && source) bubble.innerHTML = source.innerHTML;
    }

    openDrawer();
  };

  const addVariant = async ({ id, quantity = 1, properties = {} }) => {
    if (!id) return;

    const body = JSON.stringify({
      id: Number(id),
      quantity: Math.max(1, Number(quantity) || 1),
      properties,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    const response = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body,
    });

    const data = await response.json();

    if (!response.ok || data.status) {
      const message = data.description || data.message || 'Unable to add this product to cart.';
      throw new Error(message);
    }

    renderCartSections(data.sections);
    document.dispatchEvent(new CustomEvent('premium:cart:added', { detail: data }));
    return data;
  };

  document.addEventListener('click', async (event) => {
    const cartLink = event.target.closest('a[href]');
    if (cartLink && !cartLink.hasAttribute('data-premium-view-cart')) {
      const linkUrl = new URL(cartLink.href, window.location.origin);
      const currentPath = window.location.pathname.replace(/\/$/, '');
      const cartPathClean = cartPath.replace(/\/$/, '');

      if (linkUrl.origin === window.location.origin && linkUrl.pathname.replace(/\/$/, '') === cartPathClean && currentPath !== cartPathClean) {
        const drawer = getDrawer();
        if (drawer) {
          event.preventDefault();
          openDrawer();
          return;
        }
      }
    }

    const button = event.target.closest('[data-premium-add-to-cart], [data-add-to-cart], .custom-add-to-cart');
    if (!button) return;

    const variantId = button.dataset.variantId || button.getAttribute('data-product-variant-id');
    if (!variantId) return;

    event.preventDefault();

    const originalText = button.textContent;
    button.setAttribute('aria-busy', 'true');
    button.disabled = true;

    try {
      await addVariant({
        id: variantId,
        quantity: button.dataset.quantity || 1,
      });
    } catch (error) {
      console.error(error);
      alert(error.message || 'Unable to add this product to cart.');
    } finally {
      button.removeAttribute('aria-busy');
      button.disabled = false;
      if (originalText) button.textContent = originalText;
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-premium-ajax-cart]');
    if (!form) return;

    event.preventDefault();
    const formData = new FormData(form);
    const variantId = formData.get('id');
    const quantity = formData.get('quantity') || 1;

    try {
      await addVariant({ id: variantId, quantity });
    } catch (error) {
      console.error(error);
      alert(error.message || 'Unable to add this product to cart.');
    }
  });

  window.PremiumCart = {
    add: addVariant,
    open: openDrawer,
    render: renderCartSections,
  };
})();
